export default {
  getIdSurvey(state) {
    return state.SurveyForm_id;
  },
};
